<form class="request-form" [formGroup]="manageForm">
  <ng-container *ngIf="getHeading() as heading">
    <div class="d-flex">
      <p class="TXT_TITLE w-30">{{ heading }}</p>
      <div *ngIf="pnano" class="header-info w-70">
        <span class="pnano">
          <span class="label">P&A No.: </span
          ><span class="highlight">{{ pnano }}-{{ pnayear }}</span>
        </span>
        <span class="status">
          <span class="label">Status: </span
          ><span class="highlight">{{ status }}</span>
        </span>
      </div>
    </div>

    <p class="reminder-text">
      Reminder: Thai language input is currently unsupported and may lead to
      incomplete transaction
    </p>
  </ng-container>
  <div class="form-grid">
    <div class="form-group">
      <label for="locations" class="form-label">
        <span class="required">*</span>Location:
      </label>
      <nz-select
        id="locations"
        nzShowSearch
        nzAllowClear
        formControlName="pnaLocation"
        nzPlaceHolder="Select Location"
        class="form-control"
      >
        <nz-option
          *ngFor="let location of pnaLocation"
          [nzValue]="location.code"
          [nzLabel]="location.description"
        >
        </nz-option>
      </nz-select>
    </div>

    <div class="form-group">
      <label for="groupEmail" class="form-label">Group Email:</label>
      <div class="email-group">
        <input
          id="groupEmail"
          nz-input
          formControlName="groupEmail"
          readonly
          class="form-control group-email-input"
        />
        <button
          nz-button
          nzType="link"
          type="button"
          (click)="searchGroupEmail()"
          *ngIf="showSearchEmailandReset"
          class="group-email-search-link"
        >
          <span class="group-email-link-text">Search Group Email</span>
        </button>

        <button
          nz-button
          type="button"
          nzType="link"
          nzSize="small"
          *ngIf="showSearchEmailandReset"
          (click)="clearGroupEmail()"
        >
          <img
            src="../../../../assets/icons/bin.gif"
            alt="Delete Item"
            class="attachment-icon"
          />
        </button>
      </div>
    </div>

    <div class="form-group">
      <label for="requestorName" class="form-label">
        <span class="required">*</span>Requestor Name:
      </label>
      <input
        id="requestorName"
        nz-input
        formControlName="requestorName"
        readonly
        class="form-control"
      />
    </div>

    <div class="form-group">
      <label for="alternateEmail" class="form-label"
        >Alternate Requestor:</label
      >
      <div class="email-group">
        <input
          id="alternateEmail"
          nz-input
          type="email"
          formControlName="alternateEmail"
          readonly
          class="form-control"
        />
        <button
          nz-button
          nzType="link"
          type="button"
          (click)="searchCAI()"
          *ngIf="showSearchEmailandReset"
          class="group-email-search-link"
        >
          <span class="group-email-link-text">Search Email</span>
        </button>
        <button
          nz-button
          type="button"
          nzType="link"
          nzSize="small"
          *ngIf="showSearchEmailandReset"
          (click)="clearEmail()"
        >
          <img
            src="../../../../assets/icons/bin.gif"
            alt="Delete Item"
            class="attachment-icon"
          />
        </button>
      </div>
    </div>

    <div class="form-group">
      <label for="pnaTitle" class="form-label">
        <span class="required">*</span>P&A Title:
      </label>
      <input
        id="pnaTitle"
        nz-input
        formControlName="pnaTitle"
        [readonly]="isViewMode || mode === 'otherview'"
        class="form-control"
      />
    </div>

    <div class="form-group">
      <label for="requestorRatt" class="form-label">Requestor Ref#:</label>
      <input
        id="requestorRatt"
        nz-input
        formControlName="requestorRatt"
        [readonly]="isViewMode || mode === 'otherview'"
        class="form-control"
      />
    </div>

    <div class="form-group">
      <label for="purchasingOffice" class="form-label">
        <span class="required">*</span>Purchasing Office:
      </label>
      <nz-select
        id="purchasingOffice"
        nzShowSearch
        nzAllowClear
        formControlName="selectedPurchasingOffice"
        nzPlaceHolder="Select Purchasing Office"
        [nzDisabled]="mode === 'otherview'"
        class="form-control"
      >
        <nz-option
          *ngFor="let office of purchasingOffices"
          [nzValue]="office.purchasingName"
          [nzLabel]="office.purchasingName"
        >
        </nz-option>
      </nz-select>
    </div>

    <div class="form-group">
      <label for="companyCode" class="form-label">
        <span class="required">*</span>Company Code:
      </label>
      <nz-select
        id="companyCode"
        nzShowSearch
        nzAllowClear
        formControlName="selectedCompanyCode"
        nzPlaceHolder="Select Company Code"
        (ngModelChange)="onCompanyCodeChange($event)"
        [nzDisabled]="isViewMode"
        class="form-control"
      >
        <nz-option
          *ngFor="let code of companyCodes"
          [nzValue]="code.ccnCode"
          [nzLabel]="code.ccnCode"
        >
        </nz-option>
      </nz-select>
    </div>

    <div class="form-group">
      <label for="branchPlant" class="form-label">
        <span class="required">*</span>Branch/Plant:
      </label>
      <input
        id="branchPlant"
        nz-input
        formControlName="branchPlant"
        readonly
        class="form-control"
      />
    </div>

    <div class="form-group" *ngIf="showAssignBuyers">
      <label for="assignBuyer" class="form-label">
        <span class="required">*</span>Assign Buyer:
      </label>
      <nz-select
        id="assignBuyer"
        nzShowSearch
        nzAllowClear
        formControlName="assignBuyer"
        nzPlaceHolder="Select Buyer"
        class="form-control"
      >
        <nz-option
          *ngFor="let buyer of activeBuyers"
          [nzValue]="buyer.userId"
          [nzLabel]="buyer.fullName"
        >
        </nz-option>
      </nz-select>
    </div>
  </div>

  <div class="form-actions" *ngIf="showAddDeleteButtons">
    <button nz-button nzType="default" type="button" (click)="onAddItem()">
      <img
        class="iconImage"
        src="../../../../assets/icons/new.gif"
        alt="New Item Icon"
      />
      <span class="textColor ml-15">Add New Item</span>
    </button>
    <button
      nz-button
      nzType="default"
      type="button"
      (click)="deleteSelectedItems()"
    >
      <img
        class="iconImage"
        src="../../../../assets/icons/del.gif"
        alt="Delete Icon"
      />
      <span class="textColor ml-15">Delete Selected Item</span>
    </button>
  </div>

  <div class="table-wrapper StyleTable">
    <nz-table
      #requestItems
      nzBordered
      class="StyleTable"
      [nzData]="items"
      [nzShowPagination]="false"
      [nzPageSize]="items.length"
      [nzNoResult]="customNoDataMessage"
    >
      <thead>
        <tr>
          <th *ngIf="showCheckboxes"></th>
          <th *ngIf="showItemEditAction"></th>
          <th *ngIf="showItemViewAction"></th>
          <th
            *ngIf="
              !showCheckboxes && !showItemEditAction && !showItemViewAction
            "
          ></th>
          <th>No</th>
          <th>Item Description</th>
          <th>Item Qty</th>
          <th>Item UOM</th>
          <th>JDE Item#</th>
          <th>Suggested Supplier</th>
          <th>Item Priority</th>
          <th>Attachment</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of requestItems.data; let i = index">
          <td *ngIf="showCheckboxes">
            <label
              nz-checkbox
              [nzChecked]="selectedItems.includes(item)"
              (nzCheckedChange)="toggleDelete(item, $event)"
              *ngIf="isAddMode || i === 0"
            >
            </label>
          </td>
          <td *ngIf="showItemEditAction">
            <img
              src="../../../../assets/icons/edit.gif"
              title="Edit Item"
              alt="Pencil icon representing edit action for this item in a table of purchase requests"
              (click)="navigateToEdit(item.itemId)"
              style="cursor: pointer"
            />
          </td>
          <td *ngIf="showItemViewAction">
            <img
              src="assets/icons/rights.gif"
              title="View Item"
              alt="View Item"
              (click)="navigateToView(item.itemId)"
              style="cursor: pointer"
            />
          </td>
          <td
            *ngIf="
              !showCheckboxes && !showItemEditAction && !showItemViewAction
            "
          ></td>
          <td>{{ item.itemNo }}</td>
          <td>{{ item.itemDesc }}</td>
          <td>{{ item.itemQuantity }}</td>
          <td>{{ item.itemUom }}</td>
          <td>{{ item.itemJdeItemNo }}</td>
          <td>{{ item.itemSuggestSupplier }}</td>
          <td
            [style.background-color]="getPriorityColor(item.itemPriority)"
            class="priority-cell"
          >
            {{ item.itemPriority }}
          </td>
          <td>
            <ng-container *ngIf="item.itemAttachment">
              <img
                src="../../../assets/attach_icon.gif"
                alt="Attachment Icon"
              />
            </ng-container>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <div *ngIf="comments && comments.length" class="comments-section">
    <fieldset class="comments-fieldset">
      <legend class="comments-legend">
        <span class="legend-text">Comment Lists</span>
      </legend>

      <div *ngFor="let comment of comments; let i = index" class="comment-item">
        <div class="comment-header">
          <span class="comment-author"
            >Comment By: {{ comment.cmtUpdateBy }}</span
          >
          <span class="comment-date">
            <span class="label">Date:</span>
            {{ comment.cmtUpdateDate | date : "dd-MMM-yy" }}
          </span>
        </div>

        <div class="comment-layout">
          <div class="comment-content">
            <textarea readonly class="comment-textarea">{{
              comment.cmtComment
            }}</textarea>
          </div>

          <div *ngIf="comment.cmtAttachment" class="comment-attachment">
            <div class="comment-layout">
              <button
                nz-button
                type="button"
                nzType="link"
                nzSize="small"
                (click)="downloadManual(comment.cmtAttachment)"
              >
                <img
                  src="assets/attach_icon.gif"
                  alt="View Attachment"
                  class="attachment-icon"
                />
              </button>
              <button
                nz-button
                type="button"
                nzType="link"
                nzSize="small"
                nzDanger
                (click)="goDelete(comment)"
              >
                <img
                  src="../../../../assets/icons/bin.gif"
                  alt="Delete Item"
                  class="attachment-icon"
                />
              </button>
            </div>
          </div>
        </div>

        <input
          type="hidden"
          [id]="'HdComment' + i"
          [value]="comment.cmtComment"
        />
      </div>
    </fieldset>
  </div>

  <div class="form-group comment-input-section" *ngIf="showNewCommentBox">
    <div class="comment-input-wrapper">
      <label for="comments" class="form-label">
        <i *ngIf="isAdmin || isBuyer" class="asterisk">*</i>Comment
      </label>
      <textarea
        id="comments"
        nz-input
        formControlName="comments1"
        [readonly]="isViewMode"
        rows="4"
        class="comment-input"
      ></textarea>
    </div>

    <div class="comment-input-wrapper" *ngIf="isBuyer">
      <label for="comments" class="form-label"> Attachment File </label>
      <input
        *ngIf="isEditMode && isBuyer"
        nz-input
        type="file"
        (change)="onFileChange($event)"
        class="file-input"
      />
    </div>
  </div>

  <div class="form-actions partial-edit-actions">
    <button
      nz-button
      nzType="primary"
      type="button"
      *ngIf="showSaveButton"
      (click)="requestButton('save')"
      [disabled]="(isGridEmpty && mode !== 'add') || isSaveSubmitDisabled"
      class="action-button"
    >
      SAVE
    </button>

    <button
      nz-button
      nzType="primary"
      type="button"
      *ngIf="showSubmitButton"
      (click)="requestButton('submit')"
      [disabled]="isSubmitDisabled"
      class="action-button"
    >
      SUBMIT
    </button>
    <button
      nz-button
      nzType="default"
      nzDanger
      type="button"
      *ngIf="showWithdrawButton"
      (click)="requestButton('withdraw')"
      [disabled]="isWithdrawDisabled"
      class="action-button"
    >
      WITHDRAW
    </button>

    <button
      nz-button
      type="button"
      [disabled]="disableAssign"
      nzType="primary"
      *ngIf="showAssignButton"
      (click)="requestButton('assign')"
    >
      {{ isBuyer ? "RE-ASSIGN" : "ASSIGN" }}
    </button>
    <button
      nz-button
      type="button"
      [disabled]="disableReassign"
      *ngIf="showReAssignButton"
      nzType="primary"
      (click)="requestButton('reassign')"
    >
      {{ isBuyer ? "RE-ASSIGN Purchasing Office" : "RE-ASSIGN" }}
    </button>

    <button
      nz-button
      nzType="default"
      type="button"
      (click)="requestButton('back')"
      class="action-button"
    >
      {{ isAddMode ? "CANCEL" : "BACK" }}
    </button>
    <button
      nz-button
      nzType="primary"
      nzDanger
      type="button"
      *ngIf="showRejectButton"
      (click)="requestButton('reject')"
      class="action-button"
    >
      REJECT
    </button>
    <button
      nz-button
      nzType="primary"
      nzDanger
      type="button"
      *ngIf="showCancelButton"
      (click)="requestButton('cancel')"
      class="action-button"
    >
      CANCEL
    </button>
    <button
      nz-button
      type="button"
      *ngIf="showResetButton"
      [disabled]="disableReset"
      nzType="default"
      (click)="requestButton('reset')"
      class="action-button"
    >
      RESET
    </button>
    <button
      nz-button
      type="button"
      *ngIf="showCompletePnAButton"
      [disabled]="disableReset"
      nzType="default"
      (click)="requestButton('complete')"
      class="action-button"
    >
      COMPLETE P&A
    </button>
    <button
      nz-button
      type="button"
      *ngIf="showExportItemButton"
      [disabled]="disableReset"
      nzType="default"
      (click)="requestButton('exportItem')"
      class="action-button"
    >
      EXPORT ITEM LIST
    </button>
  </div>
</form>

<app-popup
  [show]="showPopup"
  [popupData]="popupData"
  (close)="showPopup = false"
></app-popup>
